import { Card, CardContent, Typography, Box } from "@mui/material";

 const StatCard = ({ title, value, icon, color, formatCurrency }) => {
  const formattedValue = formatCurrency
  ? value.toLocaleString('en-SY', { style: 'currency', currency: 'SYP' })
      : value;

  return (
    <Card sx={{ backgroundColor: color, borderRadius: 2, boxShadow: 3 }}>
      <CardContent>
        <Box display="flex" alignItems="center" gap={2}>
          <Box sx={{ color: "#fff", fontSize: 40 }}>{icon}</Box>
          <Box>
            <Typography variant="h6" color="#fff">
              {title}
            </Typography>
            <Typography variant="h5" color="#fff" fontWeight="bold">
              {formattedValue}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
export default StatCard ;